<!-- mensaje del cliente -->
@if (mensaje().direccion === EMicaChat_DireccionMensaje.INBOUND) {
  <div class="flex items-start gap-3">
    <div
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
      [class]="getColor()"
    >
      {{ nameShort() }}
    </div>
    <div
      class="relative max-w-[90%] min-w-40 rounded-xl rounded-tl-sm bg-white px-3 py-2 text-sm text-slate-800"
    >
      <span class="text-[11px] font-bold text-[#667781]">
        {{ nombreContacto().slice(0, 20).concat('...') || 'Contacto desconocido' }}
      </span>
      @if (mensaje().tipo === EMicaChat_TipoMensaje.TEXT) {
        <p class="text-sm">{{ mensaje().texto }}</p>
      } @else {
        <app-mica-chat-mensaje-media [mensaje]="mensaje()" />
      }
      <p class="mt-1 text-right text-[10px] text-[#667781]">
        {{ mensaje().fecha | date: 'h:mm a' }}
      </p>
      @if (getReactionEmoji(); as emoji) {
        <span
          class="absolute -bottom-3 -right-2 rounded-full border border-slate-200 bg-white px-1.5 py-0.5 text-xs shadow-sm"
          >{{ emoji }}</span
        >
      }
    </div>
  </div>
} @else {
  <!-- mensaje del usuario -->
  <div class="flex">
    <div
      class="relative max-w-[90%] min-w-40 rounded-xl rounded-tr-sm bg-[#d9fdd3] px-3 py-2 text-sm text-[#111b21]"
    >
      @if (mensaje().tipo === EMicaChat_TipoMensaje.TEXT) {
        <p class="text-sm">{{ mensaje().texto }}</p>
      } @else {
        <app-mica-chat-mensaje-media [mensaje]="mensaje()" />
      }
      <div class="mt-1 flex items-center justify-end gap-1 text-[10px] text-[#667781]">
        <span>{{ mensaje().fecha | date: 'h:mm a' }}</span>
        @switch (mensaje().estado) {
          @case (EMicaChat_EstadoMensaje.ENVIADO) {
            <span>✓</span>
          }
          @case (EMicaChat_EstadoMensaje.ENTREGADO) {
            <span>✓✓</span>
          }
          @case (EMicaChat_EstadoMensaje.LEIDO) {
            <span class="text-[#53bdeb]">✓✓</span>
          }
          @case (EMicaChat_EstadoMensaje.FALLIDO) {
            <span class="font-semibold text-amber-200">⚠</span>
          }
        }
      </div>
      @if (getReactionEmoji(); as emoji) {
        <span
          class="absolute -bottom-3 -left-2 rounded-full border border-slate-200 bg-white px-1.5 py-0.5 text-xs text-slate-800 shadow-sm"
          >{{ emoji }}</span
        >
      }
    </div>
  </div>
}
